<template>
  <div>
    <v-divider v-if="index > 0"/>
    <v-list-item
        :to="{ name: 'car-request-view', params: { id: id }}"
        :replace="true"
        class="px-0"
    >
      <v-container class="pa-0 pa-md-2">
        <v-row
            class="pb-md-2"
            :no-gutters="true"
        >
          <v-col
              cols="12"
              md="auto"
          >
            <p class="text-h5 text-no-wrap">{{ title }}</p>
          </v-col>
          <v-spacer/>
          <v-col
              cols="12"
              md="auto"
              align-self="center"
          >
            <p class="font-weight-regular text-no-wrap">{{ createdAt }}</p>
          </v-col>
        </v-row>
        <v-row :no-gutters="true">
          <v-col
              cols="12"
              md="4"
              align-self="center"
              class="fill-height py-2 py-md-0"
          >
            <v-img
                :src="mainPhoto"
                class="rounded"
            />
          </v-col>
          <v-col
              align-self="start"
              class="fill-height pl-md-3"
          >
            <v-row :no-gutters="true">
              <v-col
                  cols="6"
                  lg="12"
              >
                <p class="font-weight-medium">Engine: <span class="font-weight-regular">{{ engine }}cc</span></p>
              </v-col>
              <v-col
                  cols="6"
                  lg="12"
              >
                <p class="font-weight-medium">Transmission: <span class="font-weight-regular">{{ transmission }}</span>
                </p>
              </v-col>
              <v-col
                  cols="6"
                  lg="12"
              >
                <p class="font-weight-medium">Fuel: <span class="font-weight-regular">{{ fuel }}</span></p>
              </v-col>
              <v-col
                  cols="6"
                  lg="12"
              >
                <p class="font-weight-medium">Millage: <span class="font-weight-regular">{{ millage }} km</span></p>
              </v-col>
              <v-col cols="12">
                <p class="font-weight-medium">Vin: <span class="font-weight-regular">{{ vin }}</span></p>
              </v-col>
              <v-col cols="12">
                <p class="font-weight-medium">Description: <span class="font-weight-regular">
                  <br/>
                  {{ description }}
                </span>
                </p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row
            :no-gutters="true"
            justify="start"
        >
          <v-chip
              v-if="messageIndicator"
              class="my-1 mb-md-0 mt-md-2 mr-1"
              color="success"
              prepend-icon="mdi-email"
              text="New message"
          />
          <v-chip
              :text="'Status ' + status"
              class="my-1 mb-md-0 mt-md-2 mr-1"
              prepend-icon="mdi-progress-check"
          />
          <v-chip
              :text="'Price(exw.) ' + price"
              class="my-1 mb-md-0 mt-md-2 mr-1"
              prepend-icon="mdi-car"
          />
          <v-chip
              v-if="deliveryPrice != null"
              :text="'Delivery ' + deliveryPrice"
              class="my-1 mb-md-0 mt-md-2 mr-1"
              prepend-icon="mdi-ferry"
          />
          <v-chip
              v-if="paperworkPrice != null"
              :text="'Paperwork' + paperworkPrice"
              class="my-1 mb-md-0 mt-md-2 mr-1"
              prepend-icon="mdi-text-box-check-outline"
          />
          <v-chip
              v-if="totalPrice != null"
              :text="'Total ' + totalPrice"
              class="my-1 mb-md-0 mt-md-2"
              prepend-icon="mdi-sigma"
          />
        </v-row>
      </v-container>
    </v-list-item>
  </div>
</template>

<script>

export default {
  name: "CarRequestListItem",
  props: {
    index: Number,
    id: String,
    title: String,
    createdAt: String,
    mainPhoto: String,
    engine: String,
    transmission: String,
    fuel: String,
    millage: String,
    vin: String,
    description: String,
    messageIndicator: Boolean,
    status: String,
    price: String,
    deliveryPrice: Number,
    paperworkPrice: Number,
    totalPrice: Number,
  }
}
</script>

<style scoped>

</style>